var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M24 .3C10.898.3.3 10.899.3 24 .3 37.102 10.899 47.7 24 47.7 37.102 47.7 47.7 37 47.7 24S37.101.398 24 .3zm11.102 19.2l-11.5 11.7a1.976 1.976 0 01-1.403.6c-.5 0-1-.198-1.3-.5l-6.5-5.902c-.797-.699-.899-2-.098-2.796.699-.801 2-.903 2.8-.102l5.098 4.602 10.2-10.403c.8-.8 2-.8 2.8 0 .7.7.7 2-.097 2.801zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4d9f9f1eb40cc14681ae9ff7b18781ac.svg";
export { ForwardRef as ReactComponent };